import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Credit } from './credits.model';
import { HttpClient } from '@angular/common/http';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';

export interface CreditsState extends EntityState<Credit, string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'credits', idKey: 'id' })
export class CreditsStore extends EntityStore<CreditsState> {
    constructor(private appConfig: AppConfigQuery, private http: HttpClient) {
        super();
    }

    akitaPreAddEntity(credit: Credit) {
        return this.assignId(credit);
    }

    akitaPreUpdateEntity(prevCredit: Credit, nextCredit: Credit) {
        return this.assignId(nextCredit);
    }

    /**
     * Combine Custodian, Entity, and Date to create a unique id, as Akita does not support composite identifiers.
     * @param credit
     */
    assignId(credit: Credit) {
        return {
            ...credit,
            id: `${credit.custodianEntity}_${
                credit.custodianEntity
            }_${credit.date.getTime()}` //TODO: check this after the api endpoints are ready. Great possibly needs an update.
        };
    }
}
